import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'
import React from 'react'
import { IconName } from '@fortawesome/fontawesome-svg-core'

export interface CategoryHeaderProps {
    title: string
    iconName?: IconName
}

const CategoryHeader: React.FC<CategoryHeaderProps> = (props) => {
    return (
        <div className='flex space-x-2 items-center'>
            {props.iconName && <DynamicFaIcon className='text-[--tb-primary] text-xl' iconName={props.iconName} />}
            <h3 className='text-lg mb-0'>{props.title}</h3>
        </div>
    )
}

export default CategoryHeader
